import { Component, OnInit, CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';


import { SHARED_IMPORTS } from '../shared/shared-imports';
import { ContentService } from '../../services/content.service';
import { TemperaturePipe } from '../../pipes/temperature.pipe';
import { MatIconModule } from '@angular/material/icon'; 

@Component({
	selector: 'unit-overview-component',
	standalone: true,
	templateUrl: 'components/unit-overview/unit-overview.component.html',
	imports: [...SHARED_IMPORTS, TemperaturePipe, MatIconModule],
	schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA]
})
export class UnitOverviewComponent implements OnInit {
	units: any[] = [];
	withNavbar = true;

	private content = inject(ContentService);
	private http = inject(HttpClient);
	private router = inject(Router);

	constructor() { }

	ngOnInit(): void {
		this.http.get('/api/Unit/GetAll').subscribe({
			next: (response: any) => {
				this.units = response.Scunits.sort((a: any, b: any) =>
					a.Title.localeCompare(b.Title)
				);
			},
			error: (error) => {
				console.error('UnitOverview error:', error);
			}
		});
	}

	getContent(id: string): string {
		return this.content.getContent(id);
	}

	unitClick(unit: any): void {
		this.router.navigate(['/UnitDetail', unit.UnitId]);
	}

	goBack(): void {
		this.router.navigate(['/Main']);
	}
}
